import { useTranslation } from "react-i18next";
export const useStateName = () => {
    const { t } = useTranslation("sprava-textu");
    return (state) => {
        if (!state)
            return "";
        switch (state) {
            case "MISSING_TEXT":
                return t("sprava-textu.textsTable.missingText", "Chybí text");
            case "MISSING_TRANSLATION":
                return t("sprava-textu.textsTable.missingTranslation", "Chybí překlad");
            case "NEED_REVIEW":
                return t("sprava-textu.textsTable.needReview", "Potřebuje revizi");
            case "TRANSLATED":
                return t("sprava-textu.textsTable.translated", "Přeloženo");
            default:
                return t("sprava-textu.textsTable.unknownState", "Neznámý stav");
        }
    };
};
